$(function(){
    var ChartsId = null;
    var menuItemId = null;
    if($("#charts-modal").length) {
        ChartsId = $("#charts-modal").attr("data-charts-id");
        menuItemId = $("#charts-modal").attr("data-menuitem-id");
    }

    var $modal = $("#charts-modal");
    var $body  = $modal.find(".modal-body .tab-content");
    var $nav = $modal.find("ul.tab-nav");

    function placeChartsInSystem(tabs, $loading) {
        var first = true;
        $nav.html("");

        var max = 0;
        $.each(tabs, function(k, data) {
            console.log(k, data);
            var $head = $("<li role=\"presentation\"><a></a></li>");
            var $bodyCard = $('<div class="tab-pane fade"></div>');
            $body.append($bodyCard);
            $nav.append($head);

            $head.find("a").text(k).attr("href","#"+k).on("click",function(e){
                e.preventDefault();
                max = Math.max(max, $body.parent().outerHeight());
                $body.parent().height(max);
                $body.parent().css("max-height",max + "px");
                console.log("Height",$body.height());
                $body.find(".tab-pane").removeClass("active").removeClass("in").addClass("out");
                $bodyCard.addClass("active").addClass("in");
                $nav.find("li").removeClass("active");
                $head.addClass("active");

                return false;
            });
            if(first) {
                $head.addClass("active");
                $bodyCard.addClass("active").addClass("in");
                first = false;
            }

            $.each(data,function(i,item){
                switch(item.type) {
                    case "string":
                        var $el = $('<div class="chart-string"><h5></h5></div>');
                        $el.find("h5").text(item.label+": "+item.value);
                        $el.hide();
                        $bodyCard.append($el);

                        break;
                    case "lines":
                        var $el = $('<div class="row"><div class="col-sm-12"><h5></h5><div class="flot-chart"></div>\n' +
                            '                            <div class="flc-lines hidden-xs"></div></div></div>');
                        $el.find("h5").text(item.label);
                        $el.hide();
                        $bodyCard.append($el);
                        $.plot($el.find('.flot-chart')[0], item.data, item.options);
                        break;
                    case "rows":
                        var $el = $('<div class="row"><div class="col-sm-12"><h5></h5><div class="place-of-rows extra-scroll-with-max-height"></div></div></div>');
                        if(item.label.length) {
                            $el.find("h5").text(item.label);
                        }else{
                            $el.find("h5").remove();
                        }
                        var $pr = $el.find(".place-of-rows");
                        $.each(item.rows, function(i,row){
                            var $rel = $('<a class="row" target="_blank"><div class="col-sm-6"><label></label></div><div class="col-sm-6"><span class="progress"><span></span><strong></strong></span></div></a>');
                            $rel.find(' label').text(row.label);
                            if(row.action && row.action.length) {
                                $rel.attr("href",row.action);
                            }
                            var p = row.count/item.total;
                            $rel.find(".progress span").css("right",100-Math.round(100*p) + "%");
                            $rel.find(".progress strong").text((row.count/item.total * 100).toFixed(2) + "% ("+row.count+")");
                            console.log(row.label, (row.count/item.total * 100).toFixed(2));
                            $pr.append($rel);
                        });
                        if(item.rows.length === 0) {
                            $el.find(".place-of-rows").remove();
                            $el.find(".col-sm-12").append('<div class="empty-chart">'+LANGUAGE['charts.no-data-present']+'</div>');
                        }
                        $el.hide();
                        $bodyCard.append($el);
                        break;
                }
            });
        });


        setTimeout(function(){
            $nav.fadeIn();
            $body.find(".row, .chart-string").slideDown(200, function(){

                setTimeout(function(){
                    $loading.fadeOut(500, function(){ $(this).remove(); });
                },100);

            });
        },100);



    }


    $("body").on("click","[data-charts-modal]", function(e) {
        e.preventDefault();
        $body.html('<div class="loading-charts-place"></div>');
        var $loading = $body.find(".loading-charts-place");
        $nav.html("").hide();
        $modal.modal('show');
        var opts = {};
        var $attr = $(this).attr("data-charts-modal-type-id") ;
        var $attrCharts = $(this).attr("data-charts-modal-id") ;
        if($attr) {
            opts.type_id = $attr;
        }
        if(menuItemId) {
            opts.menuitem_id = menuItemId;
        }
        var useChartsId = $attrCharts ? $attrCharts : ChartsId;

        $.getJSON("/statistics/"+useChartsId, opts, function(response){
            placeChartsInSystem(response, $loading);
        });
        return false;
    });

});